import React, { Suspense } from 'react';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div className="public-layout is-login-page">
      <Suspense fallback={null}>{children}</Suspense>
    </div>
  );
};

export default PublicLayout;

